import { QueryClient } from "@tanstack/react-query";
import axios from "axios";
import { func } from "helpers";
import {DEFAULT_BACKEND_URL} from "../helpers/env";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      cacheTime: 10000,
      staleTime: Infinity,
    },
  },
});

export const baseURL = "http://maep-api.esoko.com/maep/v1/";

export const request = axios.create({
  baseURL: `${DEFAULT_BACKEND_URL}/maep/v1/`,
});

request.interceptors.request.use(
  async (config) => {
    const session = func.getStorageJson("token");
    if (session !== "") {
      config.headers = {
        ...config.headers,
        Authorization: session,
      };
    }
    return config;
  },
  (error) =>{
    console.log(error,'**** interceptor error')
    //Promise.reject(error)
    }
);

request.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (error?.response?.status === 401 && !error.sent) {
      config.sent = true;
      // get new token
      try {
        const {
         logout
        } = React.useContext(Store);
        console.log("get refresh token",error?.response.data.message);
          if(error.response.data.jwtError){
            console.log("hello working ")
            logout()
          }
      } catch (error) {}
    }

   // return Promise.reject(error);
  }
);

export const apnData = (obj) => {
  const body = new FormData();
  for (const p in obj) {
      if (p === 'file') {
          body.append('file[0]', obj[p]);
      } else {
          body.append(p, obj[p]);
      }
  }
  return body;
}
export const apnData2 = (obj) => {
  const body = new FormData();
  for (const p in obj) {
          body.append(p, obj[p]);
  }
  return body;
}
const axiosInstance = axios.create({
  baseURL: `${DEFAULT_BACKEND_URL}/maep/v1/`,
});

const getAuthorizationHeader = () => {
  const token = func.getStorageJson("token");
  if (token) {
    return token;
  }
  return null;
};

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = getAuthorizationHeader();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const client = axiosInstance;

export const clientFd = axios.create({
  baseURL: `${DEFAULT_BACKEND_URL}/maep/v1/`,
  headers: {
    "Content-Type": 'multipart/form-data'
  },
});

export const getallCahier = async (id) => {
  // id = id || '';
  // return await axios.get(`${url}/cahier/${id}`);
  const value = localStorage.getItem("maep_cahier");
  return JSON.parse(value) || [];
};

export const addCahier = async (data) => {
  if (data) {
    const cahierDetails = await getallCahier();
    localStorage.setItem(
      "maep_cahier",
      JSON.stringify([...cahierDetails, data])
    );
  }
  // return await axios.post(`${url}/cahier`,data);
};

export const editCahier = async (id, data) => {
  return await axios.put(`${url}/cahier/${id}`, data);
};

export const deleteCahier = async (id) => {
  return await axios.delete(`${url}/cahier/${id}`);
};
export const getallStock = async (id) => {
  // id = id || '';
  // return await axios.get(`${url}/stocks/${id}`);
  const value = localStorage.getItem("maep_stock");
  return JSON.parse(value) || [];
};

export const addStock = async (data) => {
  // return await axios.post(`${url}/stocks`,data);
  if (data) {
    const stockDetails = await getallStock();
    localStorage.setItem("maep_stock", JSON.stringify([...stockDetails, data]));
  }
};

export const editStock = async (id, data) => {
  return await axios.put(`${url}/stocks/${id}`, data);
};

export const deleteStock = async (id) => {
  return await axios.delete(`${url}/stocks/${id}`);
};
